import type { ReactNode } from 'react';

export interface ShellProps {
  readonly children: ReactNode;
}

/**
 * Moldura sem chrome para rotas cuja UI Angular original também não tem
 * navbar/sidebar/footer. Não aplica skin de conta nem favicon: a tela
 * hospedada é acessada sem sessão e não depende de nenhum dos dois. O remonte do
 * conteúdo por navegação é decidido por quem o fornece.
 */
export function ChromelessShell({ children }: ShellProps): JSX.Element {
  return <>{children}</>;
}
